import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import './LargeTitle.css'

// Color
export const ColorType = {
  ACCENT: 'accent',
  BASE: 'base',
  MODEST: 'modest',
  WHITE: 'white'
}

// Font Size
export const SizeType = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  TINY: 'tiny',
  XTINY: 'xtiny'
}

// Weight
export const WeightType = {
  HEAVY: 'heavy',
  NORMAL: 'normal',
  LIGHT: 'light'
}

const LargeTitle = ({ children, size, color, weight }) => {
  return <h1 styleName={`text ${size} ${color} ${weight}`}>{children}</h1>
}

LargeTitle.propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  weight: PropTypes.string.isRequired
}

LargeTitle.defaultProps = {
  size: SizeType.MEDIUM,
  color: ColorType.BASE,
  weight: WeightType.NORMAL
}

export default compose(pure)(LargeTitle)
